module.exports = __webpack_public_path__ + "img/woman8.d64aad7e.png";